import { render } from "./SpeechToText.vue?vue&type=template&id=b3e60002"
import script from "./SpeechToText.vue?vue&type=script&lang=js"
export * from "./SpeechToText.vue?vue&type=script&lang=js"

import "./SpeechToText.vue?vue&type=style&index=0&id=b3e60002&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__